<template>
    <div>
        <template v-if="!isCollapsed">
            <div class="menu-btn">
                <Button type="primary" @click="drawerCtrl=true" :style="{width:'130px',height:'30px'}">
                    <span class="icon-increased"></span>&nbsp;&nbsp;&nbsp;线索报备
                </Button>
            </div>
            <div class="menu-btn">
                <Button type="primary" :style="{width:'130px',height:'30px'}">
                    <span class="icon-upload-01"></span>&nbsp;&nbsp;&nbsp;批量上传
                </Button>
            </div>
        </template>
        <template v-if="isCollapsed">
            <div class="menu-xs-btn">
                <Button type="primary" @click="drawerCtrl=true" :style="{width:'32px',height:'30px',padding:0}">
                    <span class="icon-increased"></span>
                </Button>
            </div>
            <div class="menu-xs-btn">
                <Button type="primary" :style="{width:'32px',height:'30px',padding:0}">
                    <span class="icon-upload-01"></span>
                </Button>
            </div>
        </template>
        <Drawer
            v-model="drawerCtrl"
            width="720"
            closable
            scrollable
            :mask-closable="true"
            :styles="styles">
            <header slot="header" style="font-weight:700;">报备结果</header>
            <!-- <clue-form></clue-form> -->
        </Drawer>
    </div>
</template>
<script>
    // import clueForm from './clueForm.vue';
    export default {
        data () {
            return {
                drawerCtrl:false,
                styles: {
                    height: '100%',
                    overflow: 'auto',
                    paddingBottom: '53px',
                    position: 'static'
                },
            }
        },
        props: [''],

        methods: {

        },
        computed:{
            isCollapsed(){
                return this.$store.getters.toggleCollapsed;
            },
        },
        created(){

        },
        beforeMount(){

        },
        mounted(){

        },
        updated(){

        },
        components: {
            // clueForm,
        },
        watch: {
            drawerCtrl(val){
                console.log(val)
            }
        }
    }
</script>
<style lang="scss" scoped>
.menu-xs-btn{
    text-align: center;
    margin-bottom:3px;
    &:first-child{
        margin-top:10px;
    }
    &:last-child{
        margin-bottom:0px;
    }
}
.menu-btn{
    text-align: center;
    margin-bottom:3px;
    &:first-child{
        margin-top:10px;
    }
    &:last-child{
        margin-bottom:0px;
    }
}
 .demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/btnComponent/btnComponent.vue